import React from "react";

export const LazyCustomFields = React.lazy(() =>
    import(/* webpackChunkName: "CustomFields" */ "./CustomFields").then(x => ({
        default: x.CustomFields
    }))
);

export const LazyCustomFieldGrouping = React.lazy(() =>
    import(/* webpackChunkName: "CustomFields" */ "./CustomFieldGrouping").then(
        x => ({
            default: x.CustomFieldGrouping
        })
    )
);

export const LazyCustomFieldSelect = React.lazy(() =>
    import(/* webpackChunkName: "CustomFields" */ "./CustomFieldSelect").then(
        x => ({
            default: x.CustomFieldSelect
        })
    )
);

export const LazyCustomFieldValue = React.lazy(() =>
    import(/* webpackChunkName: "CustomFields" */ "./CustomFieldSelect").then(
        x => ({
            default: x.CustomFieldValue
        })
    )
);
